import { render } from "./homeComponent.vue?vue&type=template&id=56e3bdcf"
import script from "./homeComponent.vue?vue&type=script&lang=js"
export * from "./homeComponent.vue?vue&type=script&lang=js"

import "./homeComponent.vue?vue&type=style&index=0&id=56e3bdcf&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__